module.exports = __webpack_public_path__ + "img/refreshBtn.dc11868a.png";